<template>
    <ul>
        <li v-for="rootMenuInfo in state.menuItems" v-bind:key="rootMenuInfo">
            <div>
                <a v-if="state.currentPagePathName === state.mainPagePathName"
                    :href="rootMenuInfo.rootPath"
                    :title="rootMenuInfo.title"><span>{{ rootMenuInfo.title }}</span></a>
                <router-link v-else
                    :to="rootMenuInfo.rootPath"
                    @click="props.onRootDepthMenuClick(rootMenuInfo)"><span>{{ rootMenuInfo.title }}</span></router-link>
                <button title="메뉴열기" @click="props.onSideButtonClick($event)"></button>
            </div>                
            <ul>
                <li v-for="twoDepthMenuInfo in rootMenuInfo.children" v-bind:key="twoDepthMenuInfo">
                    <a v-if="state.currentPagePathName === state.mainPagePathName"
                        :href="twoDepthMenuInfo.path"
                        :title="twoDepthMenuInfo.title">{{twoDepthMenuInfo.title}}</a>
                    <router-link v-else
                        :to="twoDepthMenuInfo.path"
                        :title="twoDepthMenuInfo.title"
                        @click="props.onTwoDepthMenuClick($event, rootMenuInfo, twoDepthMenuInfo)">{{twoDepthMenuInfo.title}}</router-link>
                </li>
            </ul>
        </li>
    </ul>
</template>
<script>
import { onMounted, reactive } from '@vue/runtime-core';
import { menuManagement } from '@/modules/menu-management.js';
export default {
    props: [
        // 2뎁스 메뉴 클릭 이벤트 핸들러
        'onRootDepthMenuClick',
        'onTwoDepthMenuClick',

        // 모바일버전 뎁스 메뉴 화살표 클릭 이벤트 핸들러
        'onSideButtonClick',
    ],
    setup(props) {

        // state (변수)
        const state = reactive({
            
            // 메뉴 목록
            menuItems: [],

            // 메인 페이지 경로
            mainPagePathName: '/main.html',

            // 현재 페이지 경로
            currentPagePathName: location.pathname,
        });
        
        onMounted(() => {

            // 메뉴 목록 설정
            state.menuItems = menuManagement.getMenuItems();
        });

        return {
            props,
            state,
        }
    },
}
</script>